import { Box, Button, Flex, Spinner } from "@chakra-ui/react";
import { H3, Subtitle } from "src/atoms/typography";
import Modal from "src/components/Modal";
import Icon from "./Icon";

export default function Dialog({
  isOpen,
  heading,
  text,
  icon,
  iconFill,
  iconBg,
  type,
  additionalContent,
  buttons,
  processingText,
  isProcessing = false,
  ...rest
}) {
  return (
    <Modal isOpen={isOpen} {...rest}>
      {isProcessing && (
        <Flex p="53px 196px" flexDirection="column" alignItems="center">
          <Spinner />
          {processingText && (
            <Subtitle color="mediumEmphasis" mt="16px">
              {processingText}
            </Subtitle>
          )}
        </Flex>
      )}
      {buttons && !isProcessing && (
        <>
          <Box px="24px" pt="24px" width="416px">
            <Flex alignItems={text ? "start" : "center"} mb="16px">
              <Icon
                mr="24px"
                icon={icon}
                fill={iconFill}
                type={type}
                bg={iconBg}
              />
              <Box>
                {heading && <H3 color="highEmphasis">{heading}</H3>}
                {text && (
                  <Subtitle color="mediumEmphasis" mt={heading ? "8px" : 0}>
                    {text}
                  </Subtitle>
                )}
              </Box>
            </Flex>
            {additionalContent && <Box mb="16px">{additionalContent}</Box>}
          </Box>
          <Flex px="8px" mb="8px" justifyContent="flex-end">
            {buttons[0]?.onClick ? (
              <Button
                variant="flatPrimary"
                minWidth="80px"
                onClick={buttons[0].onClick}
                disabled={buttons[0].disabled}
                {...(buttons[0].onClick && {
                  ...buttons[0].css
                })}
              >
                {buttons[0].text}
              </Button>
            ) : null}

            {buttons[1]?.onClick ? (
              <Button
                ml="8px"
                variant="flatPrimary"
                minWidth="80px"
                onClick={buttons[1].onClick}
                disabled={buttons[1].disabled}
                {...buttons[1].css}
              >
                {buttons[1].text}
              </Button>
            ) : null}
          </Flex>
        </>
      )}
    </Modal>
  );
}
